<template>
  <div :class="['payment-toggle', {'error': error}]">
    <div :class="['weekly option', {'selected': model === 'week'}]" @click="model = 'week'">
      <i class="fa fa-money-bill" />
      <span class="label">WEEK</span>
    </div>
    <div :class="['deposit option', {'selected': model === 'deposit'}]" @click="model = 'deposit'">
      <i class="fa fa-times" />
      <span class="label">AWAITING</span>
    </div>
    <div :class="['upfront option', {'selected': model === 'full'}]" @click="model = 'full'">
      <i class="fa fa-check" />
      <span class="label">FULL</span>
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'PaymentToggle',
  props: {
    value: String,
    error: String,
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
  .payment-toggle {
    display: flex;
    color: #c3c3c3;

    &.error{
      background: #f5365c8e;
      border-radius: 5px;
      padding: .5rem;
      margin: -.5rem;
      color: white;
    }

    .option {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: all .25s;
      margin-bottom: -.25rem;
      padding-right: .75rem;

      &:last-child{
        padding-right: 0;
      }
    }
    .label{
      font-size: .8rem;
    }
    .upfront{
      &:hover{
        color: #2dce88af;
      }
      &.selected{
        color: #2dce88;
      }
    }
    .weekly{
      &:hover{
        color: #f5365caf;
      }
      &.selected{
        color: #f5365c;
      }
    }
    .deposit{
      &:hover{
        color: #f39c12af;
      }
      &.selected{
        color: #f39c12;
      }
    }
  }
</style>
